"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColonizerTrainingCamp = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var ColonizerTrainingCamp = (function (_super) {
    __extends(ColonizerTrainingCamp, _super);
    function ColonizerTrainingCamp() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.COLONIZER_TRAINING_CAMP,
            tags: [Tags_1.Tags.JOVIAN, Tags_1.Tags.BUILDING],
            cost: 8,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.oxygen(5).max(); }),
            metadata: {
                description: 'Oxygen must be 5% or less.',
                cardNumber: '001',
                victoryPoints: 2,
            },
        }) || this;
    }
    ColonizerTrainingCamp.prototype.play = function () {
        return undefined;
    };
    ColonizerTrainingCamp.prototype.getVictoryPoints = function () {
        return 2;
    };
    return ColonizerTrainingCamp;
}(Card_1.Card));
exports.ColonizerTrainingCamp = ColonizerTrainingCamp;
//# sourceMappingURL=ColonizerTrainingCamp.js.map